import * as api from "services/api";
import { getErrors } from "helpers/error";

export const UPDATE_NFSE = "[NFSE UPDATE] UPDATE_NFSE";
export const UPDATE_NFSE_ERROR = "[NFSE UPDATE] UPDATE_NFSE_ERROR";
export const UPDATE_NFSE_SUCCESS = "[NFSE UPDATE] UPDATE_NFSE_SUCCESS";

export const UPLOAD_FILE = "[NFSE UPDATE] UPLOAD_FILE";
export const UPLOAD_FILE_ERROR = "[NFSE UPDATE] UPLOAD_FILE_ERROR";
export const UPLOAD_FILE_SUCCESS = "[NFSE UPDATE] UPLOAD_FILE_SUCCESS";

export const SET_VALUE = "[NFSE UPDATE] SET_VALUE";
export const CLEAR_VALUES = "[NFSE UPDATE] CLEAR_VALUES";

export function setValue(payload) {
	return dispatch => {
		dispatch({ type: SET_VALUE, payload });
	};
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function updateNfse(id, model, callback) {
	return async (dispatch, getState) => {
		dispatch({
			type: UPDATE_NFSE
		});

		try {
			const { login } = getState();

			let response = await api.sendPut(`/nfse/${id} `, model, {
				Authorization: "Bearer " + login.token
			});

			if (response.ok) {
				dispatch({
					type: UPDATE_NFSE_SUCCESS
				});

				callback && callback();
			} else {
				let result = await response.json();

				const errors = getErrors(result.errors);

				dispatch({
					type: UPDATE_NFSE_ERROR,
					payload: errors
				});

				callback && callback(errors);
			}
		} catch (error) {
			console.log(error);

			return dispatch({
				type: UPDATE_NFSE_ERROR,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function uploadFile(id, file, callback) {
	return async (dispatch, getState) => {
		dispatch({
			type: UPLOAD_FILE
		});

		try {
			const { login } = getState();

			if (!id) {
				id = login.user.id;
			}

			let response = await api.sendPostFile(`/nfse/${id}/file`, file, {
				Authorization: "Bearer " + login.token
			});

			if (response.ok) {
				dispatch({
					type: UPLOAD_FILE_SUCCESS
				});

				callback && callback();
			} else {
				let result = await response.json();
				dispatch({
					type: UPLOAD_FILE_ERROR,
					payload: getErrors(result.errors)
				});
			}
		} catch (error) {
			console.log(error);

			return dispatch({
				type: UPLOAD_FILE_ERROR,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
